export const theme = {
  colors: {
    bg: '#E4E1D8',        // холст / небелёный лён
    card: '#EEEBE3',      // off-white карточка
    ink: '#14130F',       // чёрная тушь
    sub: '#736E62',       // приглушённый серо-коричневый
    line: '#D3CFC3',      // hairline
    green: '#4F5A43',     // тёмный мох — успех
    greenSoft: '#A7AE96', // светлый мох (на тёмных фонах)
    greenAlt: '#5F6B52',
    red: '#8E3B2A',       // тёмная кровь — тревога
    redSoft: '#C98978',   // приглушённая глина (на тёмных фонах)
    accent: '#8E3B2A',
    incomeBg: '#23271D',  // очень тёмный мох для герой-блоков
    paper: '#ECE9DF',     // текст/элементы на туши (вместо зоопарка #F4F1EA/#fff)
    paperSub: '#B8B0A2',  // вторичный текст на туши (Ink-block, вторая строка тоста)
    subSoft: '#A9A493',   // будущие/пунктирные засечки, dashed-подчёрки
    frost: '#C7D3D6',     // заморозка (хитмап, инвентарь)
    frostInk: '#5A7078',  // текст/штрих на frost
    wait: '#8A6D3B',      // sync-ожидание
    // легализованные тинты туши (бывший TINTS из Trends.tsx)
    inkTints: ['#2b2a24', '#4f5a43', '#736e5f', '#9a9483', '#b9b3a3', '#cdc8b9'],
  },
  // тело — Newsreader (экранная антиква с крупным очком, читаемее на телефоне);
  // заголовки/суммы — Fraunces (живой didone, opsz+WONK)
  font: "'Newsreader','Georgia',serif",
  fontDisplay: "'Fraunces','Didot','Georgia',serif",
  radius: { sm: 2, md: 4, lg: 6, xl: 8 }, // острые углы — деконструктивизм
  maxWidth: 580,
  targetSavingsRate: 30,
} as const;

export type Theme = typeof theme;
